import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { apiService } from '../../../components/Config/api.service';
import PayslipStateBadge from './PayslipStateBadge';



const BulletinTab = ({ Report, isLoading, pdfUrl, handleCalculate, handleRecalculate, handleSendPayslip, employeeId, handleCancelPayslip, onPdfLoaded }) => {

    const handlePrintPDF = () => {
        if (!Report?.id) return;

        apiService.getBlobFile(`/payslip/pdf/${Report.id}`)
            .then(response => {
                if (response && response.data) {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `bulletin_${Report.id}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
            })
            .catch(error => {
                console.error('Erreur lors du téléchargement du PDF:', error);
                alert("Erreur lors du téléchargement du PDF");
            });
    };


    return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-h-[600px] p-6">
        <div className="mb-4 flex flex-col md:flex-row justify-between items-center">
            <div>
                <h1 className="text-2xl font-bold flex items-center">
                    Bulletin de {Report?.Employee || "l'employé sélectionné"}
                    {Report?.State && (
                        <span className="ml-3">
                            <PayslipStateBadge state={Report.State} />
                        </span>
                    )}
                </h1>
            </div>
            <div className="flex gap-2 mt-3 md:mt-0">
                {Report.State === 'cancel' | Report.State === 'done'  ?  (
                    <button
                        className="hover:bg-[--color-primary] hover:text-white btn btn-outline  rounded-full text-[--color-primary] text-sm flex items-center"
                        onClick={handleRecalculate}
                        disabled={!employeeId}
                    >
                         Remettre en attente
                    </button>
                ) : pdfUrl ? (
                    <>
                    <button
                        className="bg-[--color-primary] hover:bg-[--bg-hover] btn rounded-full text-white text-sm flex items-center"
                        onClick={handleRecalculate}
                        disabled={!Report?.id}
                    >
                        <span className="mr-1">↻</span> Recalculer
                    </button>
                    <button
                        className="bg-[--bg-color] text-[--color-primary] btn rounded-full text-sm flex items-center"
                        disabled={!pdfUrl || !Report?.id}
                        onClick={handlePrintPDF}
                    >
                        <span className="mr-1">🖨️</span> Imprimer
                    </button>
                    <button
                        className="bg-red-50 text-red-700 border border-red-300 hover:bg-red-100 btn rounded-full text-sm flex items-center"
                        onClick={handleCancelPayslip}
                        disabled={!Report?.id}
                    >
                        Annuler
                    </button>
                    </>
                ) :  (
                    <button
                        className="bg-[--color-primary] btn rounded-full text-white text-sm flex items-center"
                        onClick={handleCalculate}
                        disabled={!employeeId}
                    >
                        <span className="mr-1">+</span> Calculer
                    </button>
                )}
                
            </div>
        </div>

        <hr className="py-1 mb-4" />

        {/* Skeleton loader */}

        {/* PDF Viewer */}
        {isLoading ? (
        <div className={`h-[calc(100vh-200px)] overflow-y-auto `}>
            <div className="max-w-3xl p-4 rounded-lg bg-base-200 mx-auto space-y-4 animate-pulse">
                <div className="animate-pulse bg-base-300 h-6 w-1/4"></div>
                <div className="flex justify-end space-x-4">
                    <div className="animate-pulse bg-base-300 h-4 w-1/4"></div>
                    <div className="animate-pulse bg-base-300 h-4 w-1/6"></div>
                    <div className="animate-pulse bg-base-300 h-4 w-1/5"></div>
                </div>
                <div className="animate-pulse bg-base-300 h-[2px] w-full"></div>
                <div className="space-y-2">
                    <div className="animate-pulse bg-base-300 h-[100vh] w-4/4"></div>
                </div>
                <div className="animate-pulse bg-base-300 h-4 w-1/3 mt-8"></div>
                <p className="text-center text-sm text-gray-500 mt-6">Chargement du bulletin...</p>
            </div>
        </div>
        ) : pdfUrl && (
            <div className={`max-h-[75vh] md:h-[calc(100vh-200px)] overflow-y-auto`}>
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                    <Viewer 
                    fileUrl={pdfUrl} 
                    defaultScale={1.1}
                    renderLoader={() => { }}                
                />
                </Worker>
            </div>
        )}

        {/* Cas aucun PDF */}
        {!isLoading && !pdfUrl && (
            <p className="text-center text-gray-500">Aucun PDF à afficher</p>
        )}
    </div>
);
}

export default BulletinTab;